import { useState } from "react";

import Img from "components/atoms/Img";

/**
 *
 * @param {{
 * }} props Props for the component
 *
 */
const VideoPlayer = () => {
  const [isPlayed, setIsPlayed] = useState(false);

  const handleOnClickPlay = () => {
    setIsPlayed(true);
  };

  if (isPlayed) {
    return (
      <iframe
        src="https://www.youtube.com/embed/8RkJwKEXKPU?start=32;rel=0&amp;autoplay=1"
        width="540"
        height="381"
        frameBorder="0"
        title="BBCIncorp Client Portal - Bring your next business venture online"
        allow="accelerometer; autoplay;encrypted-media; gyroscope;picture-in-picture"
        allowFullScreen
        className=" w-full"
      ></iframe>
    );
  }

  return (
    <div className="relative overflow-hidden rounded-2xl">
      <Img
        src="/assets/images/offshore/company-formation/offshore-company-formation-video-thumbnail.png"
        wrapper={{ className: "block" }}
      />
      <div className="absolute inset-0 z-20 flex h-full w-full items-center justify-center">
        <button className="block w-1/4 " onClick={handleOnClickPlay}>
          <Img
            src="/assets/images/offshore/company-formation/icon-play.png"
            wrapper={{ className: "" }}
            className="transition-transform duration-150 hover:scale-110"
          />
        </button>
      </div>
      <div className="absolute inset-0 z-10 flex h-full w-full items-end p-4 sm:p-9">
        <p
          className=" font-bold leading-tight  text-bbc-white sm:leading-10"
          style={{ fontSize: "min(5vw, 36px)" }}
        >
          Bring your next
          <br /> business venture online
        </p>
      </div>
    </div>
  );
};

export default VideoPlayer;
